import { render, staticRenderFns } from "./PreviewGroupVideos.vue?vue&type=template&id=6cf0f5ef&scoped=true&"
import script from "./PreviewGroupVideos.vue?vue&type=script&lang=js&"
export * from "./PreviewGroupVideos.vue?vue&type=script&lang=js&"
import style0 from "./PreviewGroupVideos.vue?vue&type=style&index=0&id=6cf0f5ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf0f5ef",
  null
  
)

export default component.exports